// ============================================================
// CONFIGURAZIONE STUDIO — modifica qui tutti i dati del sito.
// I valori contrassegnati con PLACEHOLDER vanno sostituiti con
// i dati reali dello studio (telefono, WhatsApp, indirizzo...).
// ============================================================

export const SITE = {
    brand: "Sara Solferini",
    brandSuffix: "Studio Olistico · Bologna",
    city: "Bologna",
    email: "sarasolferiniolistica@gmail.com",

    phoneDisplay: "+39 340 383 5183",
    phoneHref: "tel:+393403835183",
    whatsappNumber: "393403835183",

    address: "Via Marsala 28, 40126 Bologna",

    hours: [
        { days: "Martedì — Venerdì", time: "10:00 – 20:00 · su appuntamento" },
        { days: "Sabato", time: "10:00 – 13:00 · su appuntamento" },
        { days: "Domenica e Lunedì", time: "Chiuso" },
    ],

    instagramUrl: "#", // PLACEHOLDER — profilo Instagram
    facebookUrl: "#", // PLACEHOLDER — pagina Facebook

    mapsEmbed: "https://www.google.com/maps?q=Via+Marsala+28,+40126+Bologna&output=embed",
    mapsUrl: "https://www.google.com/maps?q=Via+Marsala+28,+40126+Bologna",
};

export const WHATSAPP_LINK = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
    "Buongiorno, vorrei informazioni per prenotare un trattamento."
)}`;

export const NAV_LINKS = [
    { label: "Home", path: "/", testid: "nav-link-home" },
    { label: "Trattamenti", path: "/trattamenti", testid: "nav-link-trattamenti" },
    { label: "Chi sono", path: "/chi-sono", testid: "nav-link-chi-sono" },
    { label: "Lo studio", path: "/lo-studio", testid: "nav-link-lo-studio" },
    { label: "Recensioni", path: "/recensioni", testid: "nav-link-recensioni" },
    { label: "Contatti", path: "/contatti", testid: "nav-link-contatti" },
];

// Usati solo come riserva se il backend non risponde: la sorgente
// principale è GET /api/treatments (modificabile in backend/server.py)
export const FALLBACK_TREATMENTS = [
    {
        id: "rilassante",
        name: "Massaggio Rilassante",
        tagline: "Lentezza, respiro, quiete",
        description:
            "Movimenti fluidi e avvolgenti con oli naturali, pensati per placare la mente e distendere le tensioni accumulate.",
        duration: "60 min",
        price: "€ 50",
        image: "/images/massaggio-rilassante.jpg",
    },
    {
        id: "decontratturante",
        name: "Massaggio Decontratturante",
        tagline: "Sciogliere, in profondità",
        description:
            "Un lavoro mirato sulle tensioni muscolari di schiena, collo e spalle, per restituire libertà di movimento.",
        duration: "60 min",
        price: "€ 50",
        image: "/images/massaggio-decontratturante.jpg",
    },
    {
        id: "olistico",
        name: "Massaggio Olistico",
        tagline: "Corpo e mente, un unico dialogo",
        description:
            "Un trattamento che considera la persona nella sua interezza, unendo tecniche di contatto, ascolto e riequilibrio.",
        duration: "60 min",
        price: "€ 60",
        image: "/images/trattamento-personalizzato.jpg",
    },
    {
        id: "linfodrenante",
        name: "Massaggio Linfodrenante",
        tagline: "Leggerezza che scorre",
        description:
            "Movimenti lenti, leggeri e ritmici che favoriscono il drenaggio dei liquidi e donano una piacevole sensazione di leggerezza.",
        duration: "60 min",
        price: "€ 50",
        image: "/images/studio-b.webp",
    },
    {
        id: "balinese",
        name: "Massaggio Balinese",
        tagline: "Un viaggio lontano, restando qui",
        description:
            "Dalla tradizione indonesiana: pressioni dolci, sfioramenti e oli profumati per un abbandono profondo di corpo e mente.",
        duration: "60 min",
        price: "€ 50",
        image: "/images/studio-a.webp",
    },
    {
        id: "californiano",
        name: "Massaggio Olistico Californiano",
        tagline: "L’onda che avvolge",
        description:
            "Lunghi movimenti fluidi e continui che avvolgono tutto il corpo, per un rilassamento profondo e una sensazione di unità.",
        duration: "60 min",
        price: "€ 60",
        image: "/images/studio-c.jpg",
    },
    {
        id: "personalizzato",
        name: "Massaggio con Campane Tibetane",
        tagline: "Respiro, suono, emozioni",
        description:
            "Trattamento che si apre con la consapevolezza del respiro, per cogliere il suono delle campane tibetane e sciogliere le emozioni più profonde.",
        duration: "60 min",
        price: "€ 60",
        image: "/images/massaggio-olistico.jpg",
    },
    {
        id: "bagno-sonoro",
        name: "Bagno Sonoro Equilibrio del Sé",
        tagline: "Vibrazioni che attraversano",
        description:
            "Un'immersione nel suono: le vibrazioni delle campane tibetane avvolgono il corpo e accompagnano verso un rilassamento profondo.",
        duration: "60 min",
        price: "€ 60",
        image: "/images/equilibrio-dipinto.jpg",
    },
];

// PACCHETTI — 4 incontri con sconto 10%, validità 1 mese
export const PACKAGES = [
    { id: "pkg-rilassante", name: "Massaggio Rilassante", original: "€ 200", price: "€ 180" },
    { id: "pkg-decontratturante", name: "Massaggio Decontratturante", original: "€ 200", price: "€ 180" },
    { id: "pkg-olistico", name: "Massaggio Olistico", original: "€ 240", price: "€ 216" },
    { id: "pkg-linfodrenante", name: "Massaggio Linfodrenante", original: "€ 200", price: "€ 180" },
    { id: "pkg-balinese", name: "Massaggio Balinese", original: "€ 200", price: "€ 180" },
    { id: "pkg-californiano", name: "Massaggio Olistico Californiano", original: "€ 240", price: "€ 216" },
    { id: "pkg-campane", name: "Massaggio con Campane Tibetane", original: "€ 240", price: "€ 216" },
    { id: "pkg-bagno-sonoro", name: "Bagno Sonoro Equilibrio del Sé", original: "€ 240", price: "€ 216" },
];

export const IMAGES = {
    hero: "/images/trattamento-personalizzato.jpg",
    oil: "/images/equilibrio-dipinto.jpg",
    candles: "/images/studio-b.webp",
    ambiance: "/images/studio-a.webp",
    portrait: "/images/chi-sono.webp",
    session: "/images/studio-c.jpg",
};
